import { IconMoodPuzzled } from '@tabler/icons-preact';

import css from './NotFound.module.css';

export const NotFound = () => {
  return (
    <div class={css.root}>
      <IconMoodPuzzled class={css.icon} />
      <p class={css.message}>
        Huh…
        <br />
        There's nothing here.
      </p>
    </div>
  );
};
